

export default class {
    name = 'm1'
    data = {
        name: '姓名不重要',
        info: {
            age: 12,
            school: {
            }
        }
    }
    testName() {
        alert(this.name);
    }
}